const convertBase64toBlob = (content, contentType) => {
  contentType = contentType || '';
  const sliceSize = 512;
  const byteCharacters = window.atob(content); // method which converts base64 to binary
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, {
    type: contentType,
  }); // statement which creates the blob
  return blob;
};

export const verPdf = (data, filename) => {
  const base64PdfBlob = convertBase64toBlob(data, 'application/pdf');
  const filePdf = URL.createObjectURL(base64PdfBlob);

  //Creo un link invisible para el user
  const a = document.createElement('a');
  document.body.appendChild(a);

  a.href = filePdf;
  a.download = filename;

  //Lo descargo
  a.click();
  setTimeout(() => {
    // Limpio
    window.URL.revokeObjectURL(filePdf);
    document.body.removeChild(a);
  }, 0);
};
